import { render, staticRenderFns } from "./TheClientInfoItem.vue?vue&type=template&id=342aac65&scoped=true"
import script from "./TheClientInfoItem.vue?vue&type=script&lang=js"
export * from "./TheClientInfoItem.vue?vue&type=script&lang=js"
import style0 from "./TheClientInfoItem.vue?vue&type=style&index=0&id=342aac65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342aac65",
  null
  
)

export default component.exports